// Runs before every other module so pixel and analytics SDKs never see a
// purchase reference (Checkout Session, PaymentIntent or PayPal order id) in
// the page URL. See scrubCheckoutReturnParamsFromUrl.
import { scrubCheckoutReturnParamsFromUrl } from './checkoutReturnScrub';

scrubCheckoutReturnParamsFromUrl();
